import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from './environment';

type DemoMap = Record<string, unknown>;

const todayIso = new Date().toISOString().slice(0, 10);

const sports = [
  { id: 'sport-swim', name: 'Swimming', code: 'SWM', description: 'Pool training and beginner batches', isActive: true },
  { id: 'sport-cricket', name: 'Cricket', code: 'CRI', description: 'Nets, fitness and match coaching', isActive: true },
  { id: 'sport-football', name: 'Football', code: 'FTB', description: 'Grassroot football coaching', isActive: true },
  { id: 'sport-badminton', name: 'Badminton', code: 'BAD', description: 'Indoor court coaching', isActive: true },
  { id: 'sport-tennis', name: 'Tennis', code: 'TEN', description: 'Beginner to advanced tennis', isActive: true },
  { id: 'sport-yoga', name: 'Yoga', code: 'YOG', description: 'Fitness and wellness sessions', isActive: true }
];

const paymentModes = [
  { id: 'pay-cash', name: 'Cash' },
  { id: 'pay-upi', name: 'UPI' },
  { id: 'pay-card', name: 'Card' },
  { id: 'pay-bank', name: 'Bank Transfer' }
];

const designations = [
  { id: 'des-coach', name: 'Coach' },
  { id: 'des-reception', name: 'Receptionist' },
  { id: 'des-manager', name: 'Academy Manager' },
  { id: 'des-admin', name: 'Admin' }
];

const batches = [
  { id: 'batch-1', name: 'Morning 6 AM', sportId: 'sport-swim', sportName: 'Swimming' },
  { id: 'batch-2', name: 'Evening 5 PM', sportId: 'sport-cricket', sportName: 'Cricket' },
  { id: 'batch-3', name: 'Weekend Batch', sportId: 'sport-badminton', sportName: 'Badminton' }
];

let students = [
  { id: 'stu-001', membershipCode: 'PERKS-STU-1001', fullName: 'Aadhav Kumar', mobile: '+91 98765 43210', email: 'aadhav@example.com', status: 1, joiningDate: '2026-01-05' },
  { id: 'stu-002', membershipCode: 'PERKS-STU-1002', fullName: 'Meera Srinivasan', mobile: '+91 98400 11122', email: 'meera@example.com', status: 1, joiningDate: '2026-01-12' },
  { id: 'stu-003', membershipCode: 'PERKS-STU-1003', fullName: 'Rahul Varma', mobile: '+91 90031 44321', email: 'rahul@example.com', status: 1, joiningDate: '2026-02-03' },
  { id: 'stu-004', membershipCode: 'PERKS-STU-1004', fullName: 'Nila Joseph', mobile: '+91 94444 80808', email: 'nila@example.com', status: 1, joiningDate: '2026-02-18' },
  { id: 'stu-005', membershipCode: 'PERKS-STU-1005', fullName: 'Kabir Shah', mobile: '+91 73388 11223', email: 'kabir@example.com', status: 1, joiningDate: '2026-03-02' }
];

let staff = [
  { id: 'staff-001', staffCode: 'PERKS-STF-101', name: 'Arun Prakash', roleName: 'Coach', mobile: '+91 98840 11111', email: 'arun@perks.local', designationId: 'des-coach', assignedSportId: 'sport-cricket', status: 1 },
  { id: 'staff-002', staffCode: 'PERKS-STF-102', name: 'Priya Raman', roleName: 'Coach', mobile: '+91 98840 22222', email: 'priya@perks.local', designationId: 'des-coach', assignedSportId: 'sport-swim', status: 1 },
  { id: 'staff-003', staffCode: 'PERKS-STF-103', name: 'Divya Narayanan', roleName: 'Receptionist', mobile: '+91 98840 33333', email: 'divya@perks.local', designationId: 'des-reception', status: 1 },
  { id: 'staff-004', staffCode: 'PERKS-STF-104', name: 'Sanjay Menon', roleName: 'Admin', mobile: '+91 98840 44444', email: 'sanjay@perks.local', designationId: 'des-admin', status: 1 }
];

let attendance = [
  { id: 'att-001', personType: 1, personId: 'PERKS-STU-1001', attendanceDate: todayIso, inTime: '16:05', status: 1, method: 2, remarks: 'QR entry' },
  { id: 'att-002', personType: 1, personId: 'PERKS-STU-1002', attendanceDate: todayIso, inTime: '16:20', outTime: '17:35', status: 4, method: 2, remarks: 'QR exit' },
  { id: 'att-003', personType: 2, personId: 'PERKS-STF-101', attendanceDate: todayIso, inTime: '08:55', status: 1, method: 1, remarks: 'Manual' },
  { id: 'att-004', personType: 3, personId: 'GST-2026-018', attendanceDate: todayIso, inTime: '18:10', status: 3, method: 2, remarks: 'Guest play' }
];

let payments = [
  { id: 'payment-001', receiptNumber: 'RCP-2026-001', payerName: 'Aadhav Kumar', payerType: 'Student', totalAmount: 4500, paidAmount: 4500, balanceAmount: 0, status: 'Paid', paymentDate: todayIso, paymentMode: 'UPI' },
  { id: 'payment-002', receiptNumber: 'RCP-2026-002', payerName: 'Meera Srinivasan', payerType: 'Student', totalAmount: 5000, paidAmount: 3000, balanceAmount: 2000, status: 'Pending', paymentDate: todayIso, paymentMode: 'Cash' },
  { id: 'payment-003', receiptNumber: 'RCP-2026-003', payerName: 'Rahul Varma', payerType: 'Student', totalAmount: 3500, paidAmount: 3500, balanceAmount: 0, status: 'Paid', paymentDate: todayIso, paymentMode: 'Card' },
  { id: 'payment-004', receiptNumber: 'RCP-2026-004', payerName: 'Guest Walk-in', payerType: 'Guest', totalAmount: 800, paidAmount: 800, balanceAmount: 0, status: 'Paid', paymentDate: todayIso, paymentMode: 'UPI' }
];

let guests = [
  { id: 'guest-001', guestPassCode: 'GST-2026-018', guestName: 'Vikram S', mobile: '+91 98877 66554', email: 'vikram@example.com', sportName: 'Badminton', durationMinutes: 60, charges: 600, paymentStatus: 3, status: 'CheckedIn', bookingDate: todayIso, slotStartTime: '18:00', slotEndTime: '19:00' },
  { id: 'guest-002', guestPassCode: 'GST-2026-019', guestName: 'Ananya Bose', mobile: '+91 98877 22110', email: 'ananya@example.com', sportName: 'Tennis', durationMinutes: 90, charges: 900, paymentStatus: 2, status: 'Booked', bookingDate: todayIso, slotStartTime: '19:00', slotEndTime: '20:30' }
];

let programs = [
  { id: 'camp-001', name: 'Swimming Summer Camp - Batch A', sportId: 'sport-swim', sportName: 'Swimming', packageDays: 15, startDate: todayIso, endDate: addDays(15), fee: 4500, capacity: 30, registeredCount: 18, isActive: true },
  { id: 'camp-002', name: 'Cricket Power Camp', sportId: 'sport-cricket', sportName: 'Cricket', packageDays: 30, startDate: todayIso, endDate: addDays(30), fee: 8500, capacity: 40, registeredCount: 24, isActive: true },
  { id: 'camp-003', name: 'Badminton Starter Camp', sportId: 'sport-badminton', sportName: 'Badminton', packageDays: 7, startDate: todayIso, endDate: addDays(7), fee: 2500, capacity: 20, registeredCount: 12, isActive: true }
];

let registrations = [
  { id: 'reg-001', programName: 'Swimming Summer Camp - Batch A', studentName: 'Aadhav Kumar', trainerName: 'Priya Raman', batchName: 'Morning 6 AM', registrationDate: todayIso, feeAmount: 4500, paymentStatus: 3, completionStatus: 'Registered' },
  { id: 'reg-002', programName: 'Cricket Power Camp', studentName: 'Rahul Varma', trainerName: 'Arun Prakash', batchName: 'Evening 5 PM', registrationDate: todayIso, feeAmount: 8500, paymentStatus: 2, completionStatus: 'Payment Pending' },
  { id: 'reg-003', programName: 'Badminton Starter Camp', studentName: 'Nila Joseph', trainerName: 'Arun Prakash', batchName: 'Weekend Batch', registrationDate: todayIso, feeAmount: 2500, paymentStatus: 3, completionStatus: 'Registered' }
];

export const demoApiInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  const url = new URL(request.url);
  const path = url.pathname.replace(/^\/api\/?/, '');
  const method = request.method.toUpperCase();
  const body = (request.body ?? {}) as DemoMap;

  try {
    return respond(route(method, path, url.searchParams, body)).pipe(delay(180));
  } catch (error) {
    return throwError(() => error);
  }
};

function route(method: string, path: string, params: URLSearchParams, body: DemoMap): unknown {
  if (method === 'POST' && path === 'auth/login') return login(body);
  if (method === 'GET' && path === 'dashboard/summary') return dashboardSummary();
  if (method === 'GET' && path === 'masters/sports') return sports;
  if (method === 'POST' && path === 'masters/sports') return createSport(body);
  if (method === 'GET' && path === 'masters/payment-modes') return paymentModes;
  if (method === 'GET' && path === 'masters/staff-designations') return designations;
  if (method === 'GET' && path === 'masters/batches') return batches;
  if (method === 'GET' && path === 'students') return studentResult(params);
  if (method === 'POST' && path === 'students') return createStudent(body);
  if (method === 'GET' && path === 'staff') return staff;
  if (method === 'POST' && path === 'staff') return createStaff(body);
  if (method === 'GET' && path === 'attendance/daily') return attendance;
  if (method === 'POST' && path === 'attendance/manual') return markAttendance(body);
  if (method === 'POST' && path === 'qr/scan') return scanCard(body);
  if (method === 'GET' && path === 'payments/summary') return paymentSummary();
  if (method === 'GET' && path === 'payments/recent') return payments;
  if (method === 'POST' && path === 'payments/collect') return collectPayment(body);
  if (method === 'GET' && path === 'guest-bookings/today') return guests;
  if (method === 'POST' && path === 'guest-bookings') return createGuest(body);
  if (method === 'GET' && path === 'summer-camps/programs') return programs;
  if (method === 'POST' && path === 'summer-camps/programs') return createProgram(body);
  if (method === 'GET' && path === 'summer-camps/registrations') return registrations;
  if (method === 'POST' && path === 'summer-camps/registrations') return createRegistration(body);
  if (method === 'GET' && path.startsWith('reports/')) return reportRows(path.split('/')[1]);
  if (method === 'GET' && path === 'settings/summary') return settingsSummary();
  if (method === 'POST' && path.startsWith('qr/cards/')) return generatedCard(path);
  if (method === 'POST' && path.startsWith('guest-bookings/scan/')) return scanGuest(path);
  if (method === 'POST' && path.startsWith('guest-bookings/')) return guestAction(path);
  return {};
}

function respond(body: unknown) {
  return of(new HttpResponse({ status: 200, body }));
}

function login(body: DemoMap) {
  const email = String(body['email'] ?? '').toLowerCase();
  const password = String(body['password'] ?? '');
  if (email !== 'superadmin@sportsacademy.local' || password !== 'Admin@123') {
    throw { status: 401, error: { message: 'Invalid demo credentials' } };
  }

  return {
    accessToken: 'demo-client-token',
    expiresAt: addDays(7),
    user: {
      id: 'user-001',
      fullName: 'Super Admin',
      email,
      roles: ['SuperAdmin', 'Demo']
    }
  };
}

function dashboardSummary() {
  return {
    totalStudents: 1284,
    activeStudents: 1150,
    todayGuestPlayers: guests.length,
    summerCampStudents: registrations.length,
    todayAttendance: attendance.length,
    pendingFees: paymentSummary().pendingDues,
    staffPresentToday: staff.length
  };
}

function studentResult(params: URLSearchParams) {
  const search = String(params.get('search') ?? '').toLowerCase();
  const items = students.filter((student) =>
    !search || student.fullName.toLowerCase().includes(search) || student.membershipCode.toLowerCase().includes(search)
  );
  return { items, totalCount: items.length };
}

function createStudent(body: DemoMap) {
  const fullName = `${body['firstName'] ?? ''} ${body['lastName'] ?? ''}`.trim() || 'New Student';
  const item = {
    id: `stu-${Date.now()}`,
    membershipCode: `PERKS-STU-${1000 + students.length + 1}`,
    fullName,
    mobile: String(body['mobile'] ?? ''),
    email: String(body['email'] ?? ''),
    status: 1,
    joiningDate: todayIso
  };
  students = [item, ...students];
  return item;
}

function createSport(body: DemoMap) {
  const item = {
    id: `sport-${Date.now()}`,
    name: String(body['name'] ?? 'New Sport'),
    code: String(body['code'] ?? 'NEW'),
    description: String(body['description'] ?? ''),
    isActive: true
  };
  sports.unshift(item);
  return item;
}

function createStaff(body: DemoMap) {
  const item = {
    id: `staff-${Date.now()}`,
    staffCode: `PERKS-STF-${101 + staff.length}`,
    name: String(body['name'] ?? 'New Staff'),
    roleName: String(body['roleName'] ?? 'Coach'),
    mobile: String(body['mobile'] ?? ''),
    email: String(body['email'] ?? ''),
    designationId: String(body['designationId'] ?? designations[0].id),
    assignedSportId: body['assignedSportId'] as string | undefined,
    status: 1
  };
  staff = [item, ...staff];
  return item;
}

function markAttendance(body: DemoMap) {
  const row = {
    id: `att-${Date.now()}`,
    personType: Number(body['personType'] ?? 1),
    personId: String(body['personId'] ?? ''),
    attendanceDate: String(body['attendanceDate'] ?? todayIso),
    inTime: timeNow(),
    status: Number(body['status'] ?? 1),
    method: 1,
    remarks: String(body['remarks'] ?? 'Manual entry')
  };
  attendance = [row, ...attendance];
  return row;
}

function scanCard(body: DemoMap) {
  const cardNumber = String(body['cardNumber'] ?? 'DEMO-CARD');
  attendance = [{
    id: `att-${Date.now()}`,
    personType: cardNumber.startsWith('GST') ? 3 : 1,
    personId: cardNumber,
    attendanceDate: todayIso,
    inTime: timeNow(),
    status: 1,
    method: 2,
    remarks: 'Demo scan'
  }, ...attendance];
  return { allowed: true, message: `${cardNumber} marked as checked in.` };
}

function paymentSummary() {
  const totalCollected = payments.reduce((sum, item) => sum + item.paidAmount, 0);
  const pendingDues = payments.reduce((sum, item) => sum + item.balanceAmount, 0);
  return {
    totalCollected,
    pendingDues,
    averageFee: Math.round(totalCollected / payments.length),
    overdueAmount: pendingDues,
    overdueAccounts: payments.filter((item) => item.balanceAmount > 0).length
  };
}

function collectPayment(body: DemoMap) {
  const totalAmount = Number(body['totalAmount'] ?? 0);
  const paidAmount = Number(body['paidAmount'] ?? 0);
  const paymentMode = paymentModes.find((mode) => mode.id === body['paymentModeId'])?.name ?? 'Cash';
  const item = {
    id: `payment-${Date.now()}`,
    receiptNumber: `RCP-2026-${String(payments.length + 1).padStart(3, '0')}`,
    payerName: String(body['payerId'] ?? 'Demo Payer'),
    payerType: Number(body['payerType']) === 3 ? 'Guest' : Number(body['payerType']) === 2 ? 'Staff' : 'Student',
    totalAmount,
    paidAmount,
    balanceAmount: Math.max(0, totalAmount - paidAmount),
    status: totalAmount - paidAmount > 0 ? 'Pending' : 'Paid',
    paymentDate: todayIso,
    paymentMode
  };
  payments = [item, ...payments];
  return item;
}

function createGuest(body: DemoMap) {
  const sport = sports.find((item) => item.id === body['sportId']) ?? sports[0];
  const durationMinutes = Number(body['durationMinutes'] ?? 60);
  const start = String(body['slotStartTime'] ?? '18:00').slice(0, 5);
  const item = {
    id: `guest-${Date.now()}`,
    guestPassCode: `GST-2026-${String(20 + guests.length).padStart(3, '0')}`,
    guestName: String(body['guestName'] ?? 'Demo Guest'),
    mobile: String(body['mobile'] ?? ''),
    email: String(body['email'] ?? ''),
    sportName: sport.name,
    durationMinutes,
    charges: durationMinutes === 120 ? 1200 : durationMinutes === 90 ? 900 : 600,
    paymentStatus: body['markPaid'] ? 3 : 2,
    status: 'Booked',
    bookingDate: String(body['bookingDate'] ?? todayIso),
    slotStartTime: start,
    slotEndTime: addMinutes(start, durationMinutes)
  };
  guests = [item, ...guests];
  return item;
}

function guestAction(path: string) {
  const [, id, action] = path.split('/');
  const guest = guests.find((item) => item.id === id);
  if (!guest) return {};
  if (action === 'check-in') guest.status = 'CheckedIn';
  if (action === 'check-out') guest.status = 'CheckedOut';
  if (action === 'mark-paid') guest.paymentStatus = 3;
  if (action === 'payment-qr') return paymentQr(guest);
  if (action === 'qr-pass') return qrPass(guest);
  return guest;
}

function createProgram(body: DemoMap) {
  const sport = sports.find((item) => item.id === body['sportId']) ?? sports[0];
  const item = {
    id: `camp-${Date.now()}`,
    name: String(body['name'] ?? 'New Camp Program'),
    sportId: sport.id,
    sportName: sport.name,
    packageDays: Number(body['packageDays'] ?? 15),
    startDate: String(body['startDate'] ?? todayIso),
    endDate: String(body['endDate'] ?? addDays(15)),
    fee: Number(body['fee'] ?? 0),
    capacity: Number(body['capacity'] ?? 30),
    registeredCount: 0,
    isActive: true
  };
  programs = [item, ...programs];
  return item;
}

function createRegistration(body: DemoMap) {
  const program = programs.find((item) => item.id === body['programId']) ?? programs[0];
  const student = students.find((item) => item.id === body['studentId']) ?? students[0];
  program.registeredCount += 1;
  const item = {
    id: `reg-${Date.now()}`,
    programName: program.name,
    studentName: student.fullName,
    trainerName: staff.find((item) => item.id === body['trainerStaffId'])?.name ?? 'Not assigned',
    batchName: batches.find((item) => item.id === body['batchId'])?.name ?? 'Not assigned',
    registrationDate: todayIso,
    feeAmount: program.fee,
    paymentStatus: body['markPaid'] ? 3 : 2,
    completionStatus: body['markPaid'] ? 'Registered' : 'Payment Pending'
  };
  registrations = [item, ...registrations];
  return item;
}

function generatedCard(path: string) {
  const parts = path.split('/');
  const personType = parts[2] ?? 'Student';
  const personId = decodeURIComponent(parts[3] ?? 'DEMO');
  const cardNumber = `${personType.slice(0, 3).toUpperCase()}-${Date.now().toString().slice(-6)}`;
  return { cardNumber, qrPayload: JSON.stringify({ cardNumber, personType, personId, demo: true }) };
}

function scanGuest(path: string) {
  const cardNumber = decodeURIComponent(path.split('/').pop() ?? '');
  const guest = guests.find((item) => item.guestPassCode === cardNumber) ?? guests[0];
  if (guest.paymentStatus !== 3) {
    return { allowed: false, message: 'Payment pending. Please complete payment.', guestName: guest.guestName, status: guest.status };
  }
  guest.status = guest.status === 'CheckedIn' ? 'CheckedOut' : 'CheckedIn';
  return { allowed: true, message: 'Guest pass updated successfully.', direction: guest.status === 'CheckedIn' ? 'In' : 'Out', guestName: guest.guestName, status: guest.status };
}

function reportRows(endpoint: string) {
  const reports: Record<string, unknown[]> = {
    students,
    'guest-play': guests,
    attendance,
    'fee-collection': payments,
    'due-fees': payments.filter((item) => item.balanceAmount > 0)
  };
  return reports[endpoint] ?? [];
}

function settingsSummary() {
  return {
    sports: sports.length,
    batches: batches.length,
    feePlans: 8,
    paymentModes: paymentModes.length,
    staffDesignations: designations.length,
    guestRates: 6
  };
}

function qrPass(guest: typeof guests[number]) {
  return {
    bookingId: guest.id,
    guestName: guest.guestName,
    email: guest.email ?? '',
    cardNumber: guest.guestPassCode,
    scanUrl: `/guest-scan/${guest.guestPassCode}`,
    qrSvg: qrSvg(guest.guestPassCode),
    emailSent: true,
    emailMessage: 'Demo QR pass generated. Email sending is simulated.'
  };
}

function paymentQr(guest: typeof guests[number]) {
  return {
    bookingId: guest.id,
    guestName: guest.guestName,
    amount: guest.charges,
    upiLink: `upi://pay?pa=perks@upi&pn=PERKS&am=${guest.charges}`,
    qrSvg: qrSvg(`PAY:${guest.guestPassCode}:${guest.charges}`)
  };
}

function qrSvg(text: string): string {
  const encoded = Array.from(text).reduce((hash, char) => hash + char.charCodeAt(0), 0);
  const cells = Array.from({ length: 49 }, (_, index) => ((index * 17 + encoded) % 5) < 2);
  const rects = cells.map((on, index) => on ? `<rect x="${(index % 7) * 18}" y="${Math.floor(index / 7) * 18}" width="14" height="14"/>` : '').join('');
  return `<svg viewBox="0 0 126 126" xmlns="http://www.w3.org/2000/svg"><rect width="126" height="126" fill="#fff"/><g fill="#111827">${rects}</g></svg>`;
}

function addDays(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
}

function timeNow(): string {
  return new Intl.DateTimeFormat('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date());
}

function addMinutes(start: string, minutes: number): string {
  const [hour, minute] = start.split(':').map(Number);
  const date = new Date();
  date.setHours(hour, minute + minutes, 0, 0);
  return date.toTimeString().slice(0, 5);
}
